import React from "react";
import Linkedin from "./assets/052-linkedin.svg";
import Messenger from "./assets/025-messenger.svg";
import Twitter from "./assets/096-twitter.svg";
import QTIcon from "./assets/qtIcon.svg";
import styles from "./Footer.module.scss";
import { Link } from "react-router-dom";

const { footer, block, blocks, block1, block4, ends } = styles;
const Footer = () => {
  return (
    <footer className={`${footer} global-lr-pad`}>
      <div className={blocks}>
        <Block cN={block1}>
          <p>
            <img src={QTIcon} alt="QT ICON" />
            <span>WeQuick Pay</span>
          </p>
          <p>
            SHOP - PAY - SAVE <br />
            Get the App.
          </p>
          <div>
            <img src={Messenger} alt="Messenger" />
            <img src={Twitter} alt="Twitter" />
            <img src={Linkedin} alt="Linkedin" />
          </div>
        </Block>
        <Block>
          <h3>Company</h3>
          <p>
            <Link to="/about">About Us</Link>
            <Link to="/features">Features</Link>
            <Link to="/contact">Contact Us</Link>
            <Link to="#">Carears</Link>
          </p>
        </Block>
        <Block>
          <h3>Resources</h3>
          <p>
            <Link to="/#">Store Setup</Link>
            <Link to="/#">Payment</Link>
            <Link to="/#">QR Code</Link>
            <Link to="/#">Virtual Wallet</Link>
          </p>
        </Block>
        <Block cN={block4}>
          <h3>Contact Us</h3>
          <p>
            * Will send you weekly updates for your better finance management.
          </p>
        </Block>
      </div>
      <div className={ends}>
        <p>
          <span>Careers</span>
          <span>Privacy Policy</span>
          <span>Terms & Conditions</span>
        </p>
        <p>© 2021 wequick pay. All Rights Reserved.</p>
      </div>
    </footer>
  );
};
const Block = ({ children, cN }) => (
  <div className={`${block} ${cN}`}>{children}</div>
);
export default Footer;
